import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import UnderlinedTabs from '@wix/da-ds/pkg/Tabs/dsPresets/UnderlinedTabs';
import { BiData, ContentNavbarClickBiEvent } from '@wix/da-bi/pkg/events';

export enum TabType {
  Files = 'files',
  Folders = 'folders',
}

interface Props {
  activeTab?: TabType;
  className?: string;
  onChange: (tab: TabType) => void;
}

const StashTabsMobile: FC<Props> = ({
  activeTab,
  className,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <UnderlinedTabs
      className={className}
      activeIndex={activeTab}
      items={[
        {
          index: TabType.Files,
          label: t('studio.header.tabs.stash.subtabs.files'),
          biData: BiData<ContentNavbarClickBiEvent>({
            evid: 120,
            link_name: 'files',
          }),
        },
        {
          index: TabType.Folders,
          label: t('studio.header.tabs.stash.subtabs.folders'),
          biData: BiData<ContentNavbarClickBiEvent>({
            evid: 120,
            link_name: 'folders',
          }),
        },
      ]}
      onChange={onChange}
      uniformTabWidth
    />
  );
};
StashTabsMobile.displayName = 'StashTabsMobile';

export default StashTabsMobile;
